import environment from '../services/environment';
import { FormItem } from '../store/refinance/RefinanceContext';
import { parseDate } from './dates';

export const isNumber = (value: any) => !isNaN(Number(value));
export const isValidDate = (value: any) => {
	//if (/^(0?[1-9]|[12][0-9]|3[01])[/-](0?[1-9]|1[012])[/-]\d{4}$/.test(value)) {
		if (parseDate(value) instanceof Date && !isNaN(parseDate(value).getTime())) {
			return true;
		}
	//}
	return false;
}

export const getDefaultValue = (values: FormItem | undefined, key: string): any => {
	if (values && environment.isLocal) {
		return values[key];
	}
}

export const getMortgageForm = (mortgage: number, humanReadable?: boolean): string => {
	let type = '';
	switch (mortgage) {
		case 4:
			type = (!humanReadable) ? 'Annuiteitenhypotheek' : 'Annuïteitenhypotheek'
			break;
		case 6:
			type = (!humanReadable) ? 'Aflossingsvrije_hypotheek' : 'Aflossingsvrije hypotheek';
			break;
		case 9:
			type = (!humanReadable) ? 'Lineaire_hypotheek' : 'Lineaire hypotheek';
			break;
		default:
			type = 'Aflossingsvrije_hypotheek';
			break;
	}

	return type;
}

export const getMarketValuePercentage = (percentage: number | undefined, isNhg: boolean): number => {
	if (isNhg) return 0;

	if (percentage) {
		const p = Math.round(percentage);
		if (p > 80) return 100;
		if (p > 60) return 80;
		return 60;
	}

	return  0;
}

export const isWholeNumber = (value: number) => {
	return value % 1 === 0
}


export const isPercentage = (value: string) => {
	return /(^100([.]0{1,2})?)$|(^\d{1,2}([,]\d{1,2})?)$/.test(value);
}
